/* The reviews slider: one card at a time, sliding on its own so a visitor sees there is more
   than one shop here (Kevin, 2026-08-21: "actively sliding as people come on there").

   Rules it keeps:
   · pauses while a pointer is over it or anything inside has focus — nobody loses a sentence
     they were reading to the timer;
   · a dot press is a decision, so it also resets the timer;
   · prefers-reduced-motion gets no auto-advance and no animation at all — the dots still work;
   · one slider per page is the design, but querySelectorAll costs nothing and breaks nothing. */
(function () {
  document.querySelectorAll("[data-sw-reviews]").forEach(function (root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll(".sw-review"));
    if (cards.length < 2) return;
    var dots = Array.prototype.slice.call(
      (root.parentElement || document).querySelectorAll("[data-sw-dot]")
    );
    var interval = Math.max(2000, parseInt(root.getAttribute("data-interval") || "4000", 10) || 4000);
    var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var at = 0, timer = null, paused = false;

    function show(i) {
      at = (i + cards.length) % cards.length;
      cards.forEach(function (c, k) { c.classList.toggle("is-current", k === at); });
      dots.forEach(function (d, k) { d.classList.toggle("is-on", k === at); });
      // The tallest card sets the band's height once, so the page never jumps under the reader.
      var h = 0;
      cards.forEach(function (c) { h = Math.max(h, c.offsetHeight); });
      root.style.minHeight = h + "px";
    }

    function tick() { if (!paused) show(at + 1); }
    function arm() { if (!reduced && !timer) timer = setInterval(tick, interval); }
    function rearm() { if (timer) { clearInterval(timer); timer = null; } arm(); }

    root.addEventListener("mouseenter", function () { paused = true; });
    root.addEventListener("mouseleave", function () { paused = false; });
    root.addEventListener("focusin", function () { paused = true; });
    root.addEventListener("focusout", function () { paused = false; });
    // A touch is a reader too — hold still for one full interval after any touch.
    root.addEventListener("touchstart", function () { paused = true; setTimeout(function () { paused = false; }, interval); }, { passive: true });

    dots.forEach(function (d, k) {
      d.addEventListener("click", function () { show(k); rearm(); });
    });

    show(0);
    arm();
    window.addEventListener("resize", function () { root.style.minHeight = ""; show(at); });
  });
})();
